module.exports = __webpack_public_path__ + "media/images/facilities/tv screen-18509fb3ddbc38bca69951b44599802a.png";